import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'sourcechannel', method: 'GET', body: null, token: token })
}
